import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '~env/environment';
import { MediaObserver } from '@angular/flex-layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { TitleService } from '~shared/services/title.service';

@Component({
  selector: 'app-newsletter-landing',
  templateUrl: './newsletter-landing.component.html',
  styleUrls: ['./newsletter-landing.component.scss'],
})
export class NewsletterLandingComponent implements OnInit, OnDestroy {
  constructor(public router: Router, private mediaObserver: MediaObserver, private titleService: TitleService) {}

  newsLetterLandingImage = `${environment.cdnBaseUrl()}/images/hp-newsletter-bg.svg`;
  newsLetterLandingImageMobile = `${environment.cdnBaseUrl()}/images/hp-mobile-newsletter-bg.svg`;
  destroySubject = new Subject();
  isMobile = false;
  marketplaceLink = environment.appBaseUrl();

  ngOnInit(): void {
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.destroySubject))
      .subscribe(() => {
        this.isMobile =
          this.mediaObserver.isActive(MEDIA_ALISES.mobile) || this.mediaObserver.isActive(MEDIA_ALISES.tablet);
      });
    this.titleService.setTitle([{ title: 'TITLE.PAGE.HOME' }]);
  }

  onClick(): void {
    window.location.href = this.marketplaceLink;
  }

  ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
}
